export enum ColorsEnum {
  LIGHT_BLUE = '#30a0e6',
  MOSSY_GREEN = '#68ac3c',
  BLUE_GREY = '#3a5171',
  DOC_PURPLE = '#ad6dd1',
  LIGHT_GRAY = '#7e7e7e',
}
